// extracted by mini-css-extract-plugin
module.exports = {"button":"EvaluationButton_button__3cxI7","isBad":"EvaluationButton_isBad__hjZeV"};